import { fetcher } from "helpers/fetcher";

import { TUpdateStaffStatusReq, TUpdateStaffStatusRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateStaffStatus = async (payload: TUpdateStaffStatusReq) => {
  return await fetcher<TUpdateStaffStatusRes, TUpdateStaffStatusReq["data"]>(
    ENDPOINT.CORPORATION.UPDATE_STAFF_STATUS,
    {
      data: payload.data,
      headers: {
        [API_HEADER.USER_ID]: payload.idUser,
        [API_HEADER.CORP_ID]: payload.corpId,
      },
    }
  );
};

export const mutationUpdateStaffStatus = async (
  payload: TUpdateStaffStatusReq
) => {
  return (await updateStaffStatus(payload)).data;
};

mutationUpdateStaffStatus._key = (payload: TUpdateStaffStatusReq) => [
  ENDPOINT.CORPORATION.UPDATE_STAFF_STATUS.url,
  payload,
];
